// This file could contain JS helpers. Or you could remove it, it's up to you!
export const justTestingAnImport = "I'm here to help!";

export const debounce = (fn, delay = 100) => {
    let timer = null
    return () => {
        let context = this, args = arguments
        clearTimeout(timer)
        timer = setTimeout(() => {
            fn.apply(context, args)
        }, delay)
    }
}

export const throttle = (fn, wait = 100) => {
    let time = Date.now()
    return () => {
        if ((time + wait - Date.now()) < 0) {
            fn()
            time = Date.now()
        }
    }
}

export const lockPage = () => {
    document.querySelector('body').classList.add('body--locked')
}

export const unlockPage = () => {
    document.querySelector('body').classList.remove('body--locked')
}

